// extracted by mini-css-extract-plugin
export var askAiIcon = "_mm-j";
export var category = "_mm-9";
export var categoryHeader = "_mm-e";
export var container = "_mm-0";
export var group = "_mm-a";
export var groupItems = "_mm-f";
export var groupSeparator = "_mm-k";
export var loading = "_mm-1";
export var noResults = "_mm-3";
export var placeholder = "_mm-2";
export var resultContent = "_mm-5";
export var resultIcon = "_mm-c";
export var resultItem = "_mm-g";
export var resultMeta = "_mm-8";
export var resultSubtitle = "_mm-7";
export var resultSuffix = "_mm-i";
export var resultTitle = "_mm-6";
export var resultsList = "_mm-4";
export var searchGroup = "_mm-d";
export var selected = "_mm-h";
export var subgroup = "_mm-b";